<template>
  <div class="app-container">
    <el-tabs v-model="listQuery.status" type="card" @tab-click="SearchData">
      <el-tab-pane label="已发起" name="1" />
      <el-tab-pane label="已同意" name="2" />
      <el-tab-pane label="已拒绝" name="3" />
      <el-tab-pane label="已取消" name="4" />
    </el-tabs>
    <!--查询过滤-->
    <div class="filter-container" style="display:inline-block;float:right;">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="search_time">
          <div class="block" style="display: inline-block;margin-bottom: 10px;vertical-align: middle">
            <el-date-picker v-model="listQuery.search_time" style="width:400px;" type="daterange" range-separator="~" start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item prop="search">
          <el-input v-model="listQuery.search" :placeholder="'请输入订单号'" clearable style="width: 200px;" class="filter-item" />
        </el-form-item>
        <el-form-item prop="type">
          <el-select v-model="listQuery.type" class="filter-item" clearable filterable placeholder="请选择订单类型">
            <el-option v-for="item in typeArray" :key="item.id" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="nickname">
          <el-input v-model="listQuery.nickname" :placeholder="'请输入用户姓名'" clearable style="width: 200px;" class="filter-item" />
        </el-form-item>
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
      </el-form>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" fit border highlight-current-row style="width: 100%" @sort-change="sortChange">
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <!-- 售后信息 -->
          <ul class="info el-row">
            <li class="el-col el-col-12">
              <label class="info-label">售后状态:</label>
              <div class="info-content">{{ mapstatus(row.status) }}</div>
            </li>
            <!-- <li class="el-col el-col-12">
              <label class="info-label">商品名称:</label>
              <div class="info-content">
                <el-tag v-for="item in row.goods_name" :key="item" style="margin-right:10px;">{{ item }}</el-tag>
              </div>
            </li> -->
            <li class="el-col el-col-12">
              <label class="info-label">支付方式:</label>
              <div class="info-content">
                <!-- <el-tag v-if="row.pay_type == 1" type="success">微信支付</el-tag>
                <el-tag v-else-if="row.pay_type == 2" type="warning">余额支付</el-tag>
                <el-tag v-else>套餐抵消</el-tag> -->
                <el-tag v-if="row.money > 0" type="success" style="margin:2px;">微信支付</el-tag>
                <el-tag v-if="row.balance > 0" type="warning" style="margin:2px;">余额支付</el-tag>
                <el-tag v-if="row.combo > 0" style="margin:2px;">套餐抵消</el-tag>
              </div>
            </li>
            <li v-if="row.money > 0" class="el-col el-col-12"><label class="info-label">退款金额:</label>
              <div class="info-content">{{ row.money }}</div>
            </li>
            <li v-if="row.balance > 0" class="el-col el-col-12"><label class="info-label">退款余额:</label>
              <div class="info-content">{{ row.balance }}</div>
            </li>
            <li v-if="row.combo > 0" class="el-col el-col-12"><label class="info-label">退款课时:</label>
              <div class="info-content">{{ row.combo }}</div>
            </li>
            <li class="el-col el-col-12"><label class="info-label">售后原因:</label>
              <div class="info-content">{{ row.apply_reason }}</div>
            </li>

            <li><label class="info-label">申请时间:</label>
              <div class="info-content">{{ row.apply_time }}</div>
            </li>
            <li v-if="row.status === 3"><label class="info-label">拒绝原因:</label>
              <div class="info-content">{{ row.fail_reason }}</div>
            </li>
          </ul>
          <!--/ 售后信息 -->
        </template>
      </el-table-column>
      <el-table-column width="200" align="center" label="订单号" prop="out_trade_no" />
      <!-- <el-table-column  label="商户名称" align="center" prop="merchant_name"></el-table-column> -->
      <el-table-column align="center" label="下单用户" prop="nickname" />
      <el-table-column align="center" prop="type" label="订单类型 ">
        <template slot-scope="scopes">
          <span v-if="scopes.row.order_type==1">预约场地</span>
          <span v-else>{{ typeArrayItem(scopes.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="支付方式" prop="pay_type">
        <template slot-scope="scope">
          <!-- <el-tag v-if="scope.row.pay_type == 1" type="success">微信支付</el-tag>
          <el-tag v-else-if="scope.row.pay_type == 2" type="warning">余额支付</el-tag>
          <el-tag v-else>套餐抵消</el-tag> -->
          <el-tag v-if="scope.row.money > 0" type="success" style="margin:2px;">微信支付</el-tag>
          <el-tag v-if="scope.row.balance > 0" type="warning" style="margin:2px;">余额支付</el-tag>
          <el-tag v-if="scope.row.combo > 0" style="margin:2px;">套餐抵消</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="apply_reason" label="退款原因"></el-table-column>
      <el-table-column align="center" label="申请时间" prop="apply_time" sortable="custom"></el-table-column>
      <el-table-column v-if="listQuery.status==2" align="center" prop="refund_time" label="退款时间"></el-table-column>
      <el-table-column v-if="listQuery.status==3" align="center" prop="refuse_time" label="拒绝时间"></el-table-column>
      <!--行编辑按钮-->
      <el-table-column label="操作" align="center" width="230" prop="" class-name="small-padding fixed-width">
        <template slot-scope="{row}">
          <el-button v-auth="'Refund.refund_detail'" icon="el-icon-more" type="primary" size="mini" @click="Detail(row)">详情</el-button>
          <el-button v-if="row.status === 1" type="success" plain size="mini" icon="el-icon-check" @click="agreeApplication(row)">同意</el-button>
          <el-button v-if="row.status === 1" size="mini" type="danger" plain icon="el-icon-close" @click="refuseApplication(row)">拒绝</el-button>
          <el-button v-if="row.status === 5" size="mini" type="info" plain icon="el-icon-close">退款中</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!-- 退款确认modal -->
    <el-dialog title="退款确认" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form" label-position="left" label-width="100px">
        <el-form-item label="退款金额">
          <el-input-number v-model="form.refund_amount" :disabled="true" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="退款余额">
          <el-input-number v-model="form.refund_balance" :disabled="true" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="退款课时">
          <el-input-number v-model="form.refund_combo" :disabled="true" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="退款备注">
          <el-input v-model="form.success_reason" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmRefund()">同意</el-button>
      </div>
    </el-dialog>
    <!--/ 退款确认modal -->
  </div>
</template>

<script>
import api from '@/api/order/refund' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'

export default {
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      api,
      // 额外过滤条件
      listQuery: {
        status: '1',
        type: undefined,
        // 产品名称或者sn
        search: undefined
      },
      rules: {},
      typeOptions: [], // 退款原因
      props: {
        label: 'name',
        value: 'id'
      },
      statusFilters: [
        { text: '已发起', value: 1 },
        { text: '已同意', value: 2 },
        { text: '已拒绝', value: 3 },
        { text: '已取消', value: 4 }
      ],
      dialogVisible: false,
      form: {
        refund_amount: '',
        refund_balance: '',
        refund_combo: '',
        success_reason: '',
        status: 2
      },
      check: false,
      typeArray: [
        { label: '场地', value: 1 },
        // { label: '教练', value: 2 },
        { label: '会员卡', value: 3 },
        { label: '课程套餐', value: 4 },
        { label: '余额充值', value: 5 }
        // { label: "课程", value: 6 },
      ]
    }
  },
  // 详情页面的beforeRouteLeave钩子函数
  beforeRouteLeave(to, from, next) {
    if (to.name === 'AfterSaleDetail') {
      this.$store.status.tagsView.cachedViews.push('AfterSaleList')
    }
    next()
  },
  // list组价的activated钩子
  activated() {
    this.loadData() // 这是我们获取数据的函数
    this.$store.status.tagsView.cachedViews.length = 0
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
    // this.getdictionary() // 查询退款原因
  },
  methods: {
    Detail(data) {
      this.$router.push({ path: '/order/refund_detail', query: { id: data.id }})
    },
    typeArrayItem(value) {
      // 使用find方法查找数组中的对象
      const aa = this.typeArray.find(item => item.value === value)
      if (aa) {
        return aa.label
      }
      return ''
    },
    // 获取退款原因
    getdictionary() {
      api.getDictionary().then((res) => {
        this.typeOptions = res.data.refund
      })
    },
    mapstatus(value) {
      let result = ''
      this.statusFilters.forEach((res) => {
        if (res.value === value) {
          result = res.text
        }
      })
      return result
    },
    // 获取售后原因
    mapType(value) {
      let result = ''
      this.typeOptions.forEach((res) => {
        if (res.id === Number(value)) {
          result = res.title
        }
      })
      return result
    },
    // 拒绝退款的操作
    refuseApplication(row) {
      const afterSaleId = row.id
      const payment_type = row.payment_type
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w\W]+/,
        inputErrorMessage: '拒绝原因必填'
      }).then(({ value }) => {
        const data = {
          id: afterSaleId,
          refused_reason: value,
          status: 3,
          payment_type: payment_type
        }
        api.SaveRefundOrder(data).then((res) => {
          this.$message({ message: res.msg, type: 'success' })
          this.loadData()
        })
      })
    },
    // 同意按钮
    agreeApplication(row) {
      if (this.form.success_reason) {
        this.form.success_reason = ''
      }
      this.form.payment_type = row.payment_type
      this.form.refund_amount = row.money
      this.form.refund_balance = row.balance
      this.form.refund_combo = row.combo
      this.form.id = row.id
      this.form.status = 2
      this.dialogVisible = true
    },
    // 同意退款
    confirmRefund() {
      if (this.check === true) return false
      this.check = true
      api.RefundOrder(this.form).then((res) => {
        this.$message({ message: res.msg, type: 'success' })
        this.dialogVisible = false
        setTimeout(() => {
          this.loadData()
          this.check = false
        }, 2000)
      }).catch(() => {
        this.check = false
      })
    }
  }
}
</script>
